/** pair: English + Arabic (Arabic is a draft for native review). Generated/merged by the i18n helper; edit freely. */
const en = {
  "noPlayerCode": "No player is showing this code, or it has expired. Check the TV and try again.",
  "isPaired": "“{name}” is paired",
  "pickedUp": "The player picks up its credentials within a few seconds and starts playing.",
  "done": "Done",
  "trialEnded": "Your trial has ended — choose a plan to add more players.",
  "allSeatsUsed": "All {n} player seats are in use.",
  "addSeats": "Add seats",
  "orRemove": "or remove a player first.",
  "usesSeat": "Uses 1 of your {n} remaining player seat. | Uses 1 of your {n} remaining player seats.",
  "pairNote": "No additional seat is used.",
  "repairNote": "The current device is disconnected immediately. No additional seat is used.",
  "code": "Pairing code",
  "chars": "{n}/{max} characters",
  "looking": "Looking for the player…",
  "found": "Found {device} · Android API {api} ·",
  "expiresIn": "expires in {t}",
  "playerName": "Player Name",
  "namePh": "Lobby player",
  "timeZone": "Time zone",
  "tzHint": "Content runs on the player in this time zone, even offline.",
  "viewPlan": "View plan & seats →",
  "cancel": "Cancel",
  "pairing": "Pairing…",
  "addPlayer": "Add Player",
  "replaceDevice": "Replace device"
};
const ar: typeof en = {
  "noPlayerCode": "لا يوجد مشغل يعرض هذا الرمز، أو انتهت صلاحيته. تحقق من التلفاز وأعد المحاولة.",
  "isPaired": "تم إقران «{name}»",
  "pickedUp": "يستلم المشغل بيانات اعتماده خلال ثوانٍ ويبدأ العرض.",
  "done": "تم",
  "trialEnded": "انتهت فترتك التجريبية — اختر خطة لإضافة مزيد من المشغلات.",
  "allSeatsUsed": "كل مقاعد المشغلات ({n}) مستخدمة.",
  "addSeats": "إضافة مقاعد",
  "orRemove": "أو احذف مشغلًا أولًا.",
  "usesSeat": "يستخدم مقعدًا من مقاعدك المتبقية ({n}). | يستخدم مقعدك الوحيد المتبقي. | يستخدم مقعدًا من مقعديك المتبقيين. | يستخدم مقعدًا من {n} مقاعد متبقية. | يستخدم مقعدًا من {n} مقعدًا متبقيًا. | يستخدم مقعدًا من {n} مقعد متبقٍ.",
  "pairNote": "لا يُستخدم مقعد إضافي.",
  "repairNote": "يُفصل الجهاز الحالي فورًا. لا يُستخدم مقعد إضافي.",
  "code": "رمز الإقران",
  "chars": "{n}/{max} أحرف",
  "looking": "جارٍ البحث عن المشغل…",
  "found": "تم العثور على {device} · Android API {api} ·",
  "expiresIn": "ينتهي خلال {t}",
  "playerName": "اسم المشغل",
  "namePh": "مشغل الردهة",
  "timeZone": "المنطقة الزمنية",
  "tzHint": "يعمل المحتوى على المشغل بهذه المنطقة الزمنية، حتى دون اتصال.",
  "viewPlan": "عرض الخطة والمقاعد ←",
  "cancel": "إلغاء",
  "pairing": "جارٍ الإقران…",
  "addPlayer": "إضافة مشغل",
  "replaceDevice": "استبدال الجهاز"
};
export default { en, ar };
